import { apiType } from "./apiType";
import {
  IApplicantGenerateDocCreatePayload,
  IApplicantGenerateDocDeleteResponse,
  IApplicantGenerateDocListParams,
  IApplicantGenerateDocListResponse,
  IApplicantGenerateDocResponse,
} from "@/src/types/applicantGenerateDocs";

export const applicantGenerateDocsRequests = {
  create: async (
    data: IApplicantGenerateDocCreatePayload,
  ): Promise<IApplicantGenerateDocResponse | null> => {
    try {
      return await apiType.main.post<IApplicantGenerateDocResponse>(
        `/applicant-generate-docs/create`,
        data,
      );
    } catch (error) {
      console.log("This is applicant-generate-docs create error:", error);
      return null;
    }
  },

  list: async (
    params: IApplicantGenerateDocListParams = {},
  ): Promise<IApplicantGenerateDocListResponse | null> => {
    try {
      return await apiType.main.get<IApplicantGenerateDocListResponse>(
        `/applicant-generate-docs/list`,
        params,
      );
    } catch (error) {
      console.log("This is applicant-generate-docs list error:", error);
      return null;
    }
  },

  delete: async (id: number): Promise<IApplicantGenerateDocDeleteResponse | null> => {
    try {
      return await apiType.main.delete<IApplicantGenerateDocDeleteResponse>(
        `/applicant-generate-docs/delete?id=${id}`,
      );
    } catch (error) {
      console.log("This is applicant-generate-docs delete error:", error);
      return null;
    }
  },
};
